// extracted by mini-css-extract-plugin
export var container = "styles-module__container___eCDqu";
export var left = "styles-module__left___t3iSz";
export var title = "styles-module__title___SEbd5";
export var icon = "styles-module__icon___GlYLx";
export var overflowIcon = "styles-module__overflowIcon___uE80D";